import React, { useState, useEffect } from "react";
import OpenMenu from "../assets/menu_open.png";

import Guest from "../assets/sideGuestBlack.svg";

import Website from "../assets/sideWebBlack.svg";

import GuestOrng from "../assets/sideGuestOrng.svg";

import NewLogo from "../assets/logo-dark.png";
import WebsiteOrng from "../assets/sideWebOrng.svg";
import enquiryIcn from "../assets/enquiryIcn.svg";
import enquiryIcnGreen from "../assets/enquiryIcnGreen.svg";

import "./Css/SideBar.css";
import { sidebarpagetext, Hide_Menu_text } from "./../CommonJquery/WebsiteText";
import { Link, useLocation } from "react-router-dom";
import {
  retrieveData,
  removeData,
} from "../LocalConnection/LocalConnection.js";
import { server_post_data } from "../ServiceConnection/serviceconnection.js";
function SideBar({ isSidebarOpen, toggleSidebar }) {
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const access_permission = retrieveData("access_permission");
  const [page_chekt, setPage_chekt] = useState([]);
  const [rightpage, setrightpage] = useState([]);
  const [designationpage, setDesignationPage] = useState([]);

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  /******************* this useEffect Staff Right Activity Start****************/
  useEffect(() => {
    //console.log(page_chekt);
    //console.log(designationpage);
    var currentPage = window.location.pathname.split("/").pop();
    var rrr = Triosidebarhideshow(currentPage);
    if (rrr) {
      goback();
    }

    if (page_chekt[currentPage] && page_chekt[currentPage]["insidepage"]) {
      page_chekt[currentPage]["insidepage"].split("/").forEach(function (item) {
        console.log(item);
        const insidePages_vw = item.split("@");
        if (
          designationpage[currentPage] &&
          Object.values(designationpage[currentPage]).includes(
            insidePages_vw[0]
          )
        ) {
          // item is present in the designation so no need to remove
        } else {
          var elementsToRemove = document.querySelectorAll(
            "." + insidePages_vw[0]
          );
          elementsToRemove.forEach(function (element) {
            element.remove(); //remove buttons
          });
        }
      });
    }

    Object.keys(page_chekt).forEach(function (key) {
      var itempi = page_chekt[key].page_url_id;
      if (!designationpage[itempi]) {
        document.querySelectorAll(`li.${itempi}`).forEach(function (element) {
          element.remove();
        });
        document
          .querySelectorAll(`[href="/${itempi}"]`)
          .forEach(function (element) {
            element.remove();
          });
      }
    });
  }, [page_chekt]);

  /******************* this useEffect Staff Right Activity End ****************/

  function Triosidebarhideshow(pagelink) {
    if (designationpage[pagelink]) {
      return ""; // User has access to this page
    } else {
      if (!page_chekt[pagelink]) {
        return ""; // No user right for this page
      } else {
        return "dsplynoe"; // User has no right to access this page
      }
    }
  }

  /********* Current Page redirect Start**********/
  function goback() {
    window.history.back();
  }
  /********* Current Page redirect Close**********/
  return (
    <div className={`sidebar ${isSidebarOpen ? "OpneSidebar" : ""}`}>
      <div className="sidebar_container">
        <div className="sideHeadLogo">
          <a className="navbar-brand" href="#">
            <div className="headerLogo">
              <div className="headerLogo_contaienr">
                <img src={NewLogo} alt="swastik sustainable" />
              </div>
            </div>
          </a>
        </div>
        <div
          data-bs-toggle="tooltip"
          data-bs-placement="left"
          htmlFor="top"
          title={`Hide`}
          className="menuOpenClose"
          onClick={toggleSidebar}
          style={{
            paddingLeft: "0",
            marginLeft: "2rem",
            justifyContent: "flex-start",
          }}
        >
          <img
            style={{ transform: " rotate(0deg)" }}
            src={OpenMenu}
            alt="Swastik's Dashboard"
          />
          {/* <p>{Hide_Menu_text}</p> */}
        </div>
        <div className="sidebar_list">
          <ul>
            <Link to="/View_Staff">
              <li
                className={`guest_mngmt ${Triosidebarhideshow(
                  "Guest_Management"
                )}`}
              >
                <div
                  className={`sidebar_list_item ${
                    location.pathname === "/View_Staff" ? "activeSideItem" : " "
                  }`}
                >
                  <img
                    src={
                      location.pathname === "/View_Staff" ? GuestOrng : Guest
                    }
                    alt="Swastik's Dashboard"
                  />
                  <p>Staff</p>
                </div>
              </li>
            </Link>
            <Link to="/ContactData">
              <li
                className={`guest_mngmt ${Triosidebarhideshow(
                  "Guest_Management"
                )}`}
              >
                <div
                  className={`sidebar_list_item ${
                    location.pathname === "/ContactData"
                      ? "activeSideItem"
                      : " "
                  }`}
                >
                  <img
                    src={
                      location.pathname === "/ContactData"
                        ? enquiryIcnGreen
                        : enquiryIcn
                    }
                    alt="Swastik's Dashboard"
                  />
                  <p>Enquiry</p>
                </div>
              </li>
            </Link>

            <Link to="/Add_Event">
              <li
                className={`website_mngmt ${Triosidebarhideshow(
                  "Add_Event"
                )}`}
              >
                <div
                  className={`sidebar_list_item ${
                    location.pathname === "/Add_Event"
                      ? "activeSideItem"
                      : " "
                  }`}
                >
                  <img
                    src={
                      location.pathname === "/Add_Event"
                        ? WebsiteOrng
                        : Website
                    }
                    alt="swastik's Dashboard"
                  />
                  <p>Add Events</p>
                </div>
              </li>
            </Link>
            <Link to="/Website_Management">
              <li
                className={`website_mngmt ${Triosidebarhideshow(
                  "Website_Management"
                )}`}
              >
                <div
                  className={`sidebar_list_item ${
                    location.pathname === "/Website_Management"
                      ? "activeSideItem"
                      : " "
                  }`}
                >
                  <img
                    src={
                      location.pathname === "/Website_Management"
                        ? WebsiteOrng
                        : Website
                    }
                    alt="swastik's Dashboard"
                  />
                  <p>{sidebarpagetext.Website_Mngmt}</p>
                </div>
              </li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
